import React, { useState, useEffect, useContext } from "react";
import PartnerAppSurveyReadOnlyRow from "./PartnerAppSurveyReadOnlyRow";
import PartnerAppSurveyTableRow from "./PartnerAppSurveyTableRow";
import UserPartnerDD from "./UserPartnerDD";
import UserContext from "../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";


function PartnerAppSurveyTable({ key, setPartnerAppSurvey, loginId, companyId, userPartnerList, setSupplierId, supplierId }) {
    const { t } = useTranslation();
    const [add, setAdd] = useState(false);
    const [addRowTop, setAddRowTop] = useState(false);
    const [addRowBottom, setAddRowBottom] = useState(false);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [isPartnerAppSurveyLoading, setIsPartnerAppSurveyLoading] = useState(false);
    const [partnerAppSurveys, setPartnerAppSurveys] = useState([]);
    const [count, setCount] = useState(0);
    const closeText = t("page.close");
    const userCtx = useContext(UserContext);

    const initialValues = {
        loginId: loginId,
        companyId: companyId,
        partnerKey: supplierId,
        appSurveyKey: 0,
        canRead: false,
        canWrite: false,
        canReview: false,
        canReadOwn: false,
    };
    const [formValues, setFormValues] = useState(initialValues);

    const resetCounter = () => {
        setCount(prevCount => prevCount + 1);
    };

    let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
    useEffect(() => {
        if (supplierId > 0) {
            initialValues.partnerKey = supplierId;
            setFormValues({ ...formValues, ["partnerKey"]: supplierId });
            removeRowTable();
            setPartnerAppSurveys([]);
            setIsPartnerAppSurveyLoading(false);
            fetchPartnerAppSurveys();
        }
    }, [supplierId]);

    const handleClose = (event) => {
        setPartnerAppSurvey(false);
    };


    function fetchPartnerAppSurveys() {
        setError("");
        if (!initialValues.companyId || initialValues.companyId === 0
            || !initialValues.loginId || !supplierId || supplierId === 0) {
            return;
        }
        resetCounter();
        setIsPartnerAppSurveyLoading(true);
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: true, companyId: initialValues.companyId,
                loginId: initialValues.loginId, partnerKey: supplierId
            }),
        };
        try {
            FetchUtil.fetchAPI("GetUserPartnerAppSurvey", "/Service/PartnerSubsService/GetUserPartnerAppSurvey", requestOptions, retrievePartnerAppSurveySuccess, retrievePartnerAppSurveyFail);
        } catch (error) {
            setIsPartnerAppSurveyLoading(false);
            throw new Error(error.message);
        }
    }

    function retrievePartnerAppSurveyFail(redirect) {
        setIsPartnerAppSurveyLoading(false);
        if (redirect) {
            navigate("/");
        }
        setError(t("error.partnerGetAppSurveyFailed"));
    }

    function retrievePartnerAppSurveySuccess(responseData) {
        let fetchUserPartnerAppSurveysResponse;
        if (responseData) {
            fetchUserPartnerAppSurveysResponse = responseData.fetchUserPartnerAppSurveysResponse;
            if (fetchUserPartnerAppSurveysResponse && fetchUserPartnerAppSurveysResponse.errorCode === "0") {
                setPartnerAppSurveys(fetchUserPartnerAppSurveysResponse.appSurveyList.slice())
            } else if (fetchUserPartnerAppSurveysResponse && fetchUserPartnerAppSurveysResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (fetchUserPartnerAppSurveysResponse) {
                setError(t("error.error") + " " + fetchUserPartnerAppSurveysResponse.errorMessage);
            } else {
                setError(t("error.system.fetch"));
            }
        }
        setIsPartnerAppSurveyLoading(false);
    }

    const addRowTableTop = () => {
        setAddRowTop(true);
        setAddRowBottom(false);
        addRowTable();
    };

    const addRowTableBottom = () => {
        setAddRowTop(false);
        setAddRowBottom(true);
        addRowTable();
    };
    const addRowTable = () => {
        setError("");
        if (!add) {
            setAdd(true);
        } else {
            setError(t("error.only1RowAllowed"));
        }

    };

    const removeRowTable = () => {
        setError("");
        resetRowTable();
    };
    const resetRowTable = () => {
        setAddRowTop(false);
        setAddRowBottom(false);
        setAdd(false);
    };
    const handleDeleteClick = (event, userPartnerItem, completeCallback) => {
        event.preventDefault();
        deletePartnerAppSurvey(userPartnerItem, completeCallback);
    };
    const deletePartnerAppSurvey = (userPartnerItem, completeCallback) => {
        let action = 3;
        if (userPartnerItem.statusCode === 1) {
            action = 4;
        }
        let serverParams = {
            loginId: formValues.loginId,
            appSurveyKey: userPartnerItem.appSurveyKey,
            partnerKey: userPartnerItem.partnerKey,
            userCompanyId: userCompanyId,
            source: "web",
            action: action
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };

        try {
            FetchUtil.fetchAPI("DeleteUserPartnerAppSurvey", "/Service/PartnerSubsService/DeleteUserPartnerAppSurvey", requestOptions, deletePartnerAppSurveySuccess, deletePartnerAppSurveyFail, completeCallback);
        } catch (error) {
            setError(error.message);
            if (completeCallback) {
                completeCallback();
            }
        }
    };

    function deletePartnerAppSurveyFail(redirect, completeCallback) {
        setError(t("error.userAppSurveyEditFailed"));
        if (completeCallback) {
            completeCallback();
        }
    }
    function deletePartnerAppSurveySuccess(responseData, completeCallback) {
        let deleteUserPartnerAppSurveyResponse;
        if (responseData) {
            deleteUserPartnerAppSurveyResponse = responseData.deleteUserPartnerAppSurveyResponse;
            if (deleteUserPartnerAppSurveyResponse) {
                if (deleteUserPartnerAppSurveyResponse.errorCode === "0") {
                    resetRowTable();
                    refreshPartnerAppSurvey();
                } else {
                    setError(t("error.error") + " " +
                        deleteUserPartnerAppSurveyResponse.errorMessage
                    );
                }
            }
        }
        if (completeCallback) {
            completeCallback();
        }
    }

    const handleSubmit = (action, setValues, completeCallback) => {
        setError("");
        let found = false;
        if (!formValues.loginId) {
            setError(t("error.userReqd"));
            if (completeCallback) {
                completeCallback();
            }
            return false;
        }
        if (action === 1) {
            if (partnerAppSurveys.length > 0) {
                partnerAppSurveys.map((partnerAppSurveyItem, index) => {
                    if (partnerAppSurveyItem.appSurveyKey === setValues.appSurveyKey
                        && partnerAppSurveyItem.partnerKey == setValues.partnerKey) {
                        setError(t("error.userAppSurveyDup"));
                        found = true;
                        if (completeCallback) {
                            completeCallback();
                        }
                        return false;
                    }
                })
            }
            if (!found) {
                savePartnerAppSurvey(action, setValues, completeCallback);
            } else {
                if (completeCallback) {
                    completeCallback();
                }
            }
        } else if (action === 2) {
            if (partnerAppSurveys.length > 0) {
                partnerAppSurveys.map((partnerAppSurveyItem, index) => {
                    if (partnerAppSurveyItem.appSurveyKey === setValues.appSurveyKey
                        && partnerAppSurveyItem.partnerKey == setValues.partnerKey) {
                        found = true;
                    }
                })
            }
            if (found) {
                savePartnerAppSurvey(action, setValues, completeCallback);
            } else {
                if (completeCallback) {
                    completeCallback();
                }
            }
        } else if (completeCallback) {
            completeCallback();
        }
    };
    const savePartnerAppSurvey = (action, setValues, completeCallback) => {
        let serverParams = {
            loginId: formValues.loginId,
            companyId: formValues.companyId,
            partnerKey: setValues.partnerKey,
            appSurveyKey: setValues.appSurveyKey,
            canRead: setValues.canRead,
			takeCorrectiveActionOnSupplier: setValues.takeCorrectiveActionOnSupplier,
            canWrite: setValues.canWrite,
            canReview: setValues.canReview,
            canReadOwn: setValues.canReadOwn,
            source: "web",
            action: action
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };

        try {
            FetchUtil.fetchAPI("AddUpdateUserPartnerAppSurvey", "/Service/PartnerSubsService/AddUpdateUserPartnerAppSurvey", requestOptions, savePartnerAppSurveySuccess, savePartnerAppSurveyFail, completeCallback);
        } catch (error) {
            setError(error.message);
            if (completeCallback) {
                completeCallback();
            }
        }
    };

    function savePartnerAppSurveyFail(redirect, completeCallback) {
        setError(t("error.userAppSurveyEditFailed"));
        if (completeCallback) {
            completeCallback();
        }
    }
	
    function savePartnerAppSurveySuccess(responseData, completeCallback) {
        let addUpdateUserPartnerAppSurveyResponse;
        if (responseData) {
            addUpdateUserPartnerAppSurveyResponse = responseData.addUpdateUserPartnerAppSurveyResponse;
            if (addUpdateUserPartnerAppSurveyResponse) {
                if (addUpdateUserPartnerAppSurveyResponse.errorCode === "0") {
                    resetRowTable();
                    refreshPartnerAppSurvey();
                } else {
                    setError(t("error.error") + " " +
                        addUpdateUserPartnerAppSurveyResponse.errorMessage
                    );
                }
            }
        }
        if (completeCallback) {
            completeCallback();
        }
    }
	
    function refreshPartnerAppSurvey() {
        fetchPartnerAppSurveys();
    }
	
    return (
        <>
            {(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
                <div className="container-fluid container_list_sm viewh-85">
                    <div className="row">
                        <div className="col mt-3">
                            {(error) ? (
                                <div id="inerrorMessage" className="errorblock">
                                    {error}
                                </div>
                            ) : (<></>)}
                        </div>
                        {(isPartnerAppSurveyLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
                    </div>
                    <div className="row">
                        <div className="col">
                            <div id="placeholder_1" className="placeholder-pg"></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <UserPartnerDD loginId={loginId} companyId={companyId} setSupplierId={setSupplierId} userPartnerList={userPartnerList} 
                            	supplierId = {supplierId} />
                        </div>
                    </div>
                    <div className="row" style={{ margin: "0px" }}>
                        <div className="col">
                            <a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div id="placeholder_1" className="placeholder-pg"></div>
                        </div>
                    </div>
                    {(supplierId > 0) ?
                        <div className="row">
                            <div className="col">
                                <table className="list-table" role="table">
                                    <thead>
                                        <tr role="row">
                                            <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.app.name")}</th>
                                            <th className="list-th" style={{ maxWidth: "20vw" }}>{t("page.survey.name")}</th>
                                            <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.read.sup")}</th>
                                            <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.corr.sup")}</th>
                                            <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.read.own")}</th>
                                            <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.write.own")}</th>
                                            <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.review.own")}</th>
                                            <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.status")}</th>
                                            <th className="list-th" style={{ maxWidth: "12vw" }}>
                                                <button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
                                                    {t("page.addRow")}
                                                </button>&nbsp;&nbsp;
                                                <button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
                                                    {t("page.delRow")}
                                                </button>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody role="rowgroup">
                                        {add && addRowTop &&
                                            <PartnerAppSurveyTableRow
                                                index={count}
                                                partnerKey={supplierId}
                                                buyerKey={companyId}
                                                handleSubmit={handleSubmit}
                                                setError={setError}
                                                t={t}
                                                setAdd={setAdd}
                                                oddIdx={((partnerAppSurveys.length % 2) > 0) ? true : false} />
                                        }
                                        {(partnerAppSurveys.length > 0) ? (
                                            partnerAppSurveys.map((partnerAppSurveyItem, index) => (
                                                <PartnerAppSurveyReadOnlyRow
                                                    index={count}
                                                    t={t}
                                                    partnerAppSurveyItem={partnerAppSurveyItem}
                                                    handleDeleteClick={handleDeleteClick}
                                                    oddIdx={((index % 2) > 0) ? true : false}
                                                    setError={setError}
                                                    handleSubmit={handleSubmit}
                                                />
                                            ))
                                        ) : (<></>)}
                                        {add && addRowBottom &&
                                            <PartnerAppSurveyTableRow
                                                index={count}
                                                partnerKey={supplierId}
                                                buyerKey={companyId}
                                                handleSubmit={handleSubmit}
                                                setError={setError}
                                                t={t}
                                                setAdd={setAdd}
                                                oddIdx={((partnerAppSurveys.length % 2) > 0) ? true : false} />
                                        }
                                    </tbody>
                                    {(partnerAppSurveys.length > 10) ? (<tfoot>
                                        <tr role="row">
                                            <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.app.name")}</th>
                                            <th className="list-th" style={{ maxWidth: "20vw" }}>{t("page.survey.name")}</th>
                                            <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.read.sup")}</th>
                                            <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.corr.sup")}</th>
                                            <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.read.own")}</th>
                                            <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.write.own")}</th>
                                            <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.review.own")}</th>
                                            <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.status")}</th>
                                            <th className="list-th" style={{ maxWidth: "12vw" }}>
                                                <button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
                                                    {t("page.addRow")}
                                                </button>&nbsp;&nbsp;
                                                <button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
                                                    {t("page.delRow")}
                                                </button>
                                            </th>
                                        </tr>
                                    </tfoot>
                                    ) : (<></>)}
                                </table>
                                <div className="row">
                                    <div className="col mt-3">
                                        {(error) ? (
                                            <div id="inerrorMessage1" className="errorblock">
                                                {error}
                                            </div>
                                        ) : (<></>)}
                                    </div>
                                </div>
                                <div className="footer">
                                    <input
                                        type="button"
                                        name="edit-part-appsurvey-close"
                                        id="edit-part-appsurvey-close"
                                        className="btn btn-secondary btn-block" data-dismiss="modal"
                                        onClick={(e) => handleClose(e)}
                                        style={{ marginTop: "10px", marginBottom: "10px" }}
                                        value={closeText}
                                    ></input>
                                </div>
                            </div>
                        </div> :
                        (!userPartnerList || userPartnerList.length === 0) ?
                            <>
                                <div className="row">
                                    <div className="col mt-3">
                                        <div id="inerrorMessage1" className="errorblock">
                                            {t("error.partnerReqd")}
                                        </div>
                                    </div>
                                </div>
                                <div className="footer">
                                    <input
                                        type="button"
                                        name="edit-part-appsurvey-close"
                                        id="edit-part-appsurvey-close"
                                        className="btn btn-secondary btn-block" data-dismiss="modal"
                                        onClick={(e) => handleClose(e)}
                                        style={{ marginTop: "10px", marginBottom: "10px" }}
                                        value={closeText}
                                    ></input>
                                </div>
                            </> : (<></>)}
                </div>
                : null}
        </>
    );
}
export default PartnerAppSurveyTable;